import { Card, Grid, Typography, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userRoles } from 'src/models/leave.enum';
import { RootStateType } from 'src/store/RootReducer';
import EmployeeCard from './EmployeeCard';
import { getOnLeaveList } from 'src/services/leaveService';
import { AppActions } from 'src/store/AppReducer';

interface Prop {
  userRole : string | null;
  dataChange?: boolean;
}

const OnLeave = (prop : Prop) => {
  const dispatch = useDispatch();
 //get user and reporting manager
  const appUser = useSelector((state: RootStateType) => state.appReducer.user);
  const isReportingManager = useSelector((state: RootStateType) => state.leaveManagementReducer.isReportingManager);
  const isTrigger = useSelector((state: any) => state.appReducer.isTrigger);

  const [onLeaveList, setOnLeaveList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const validateUserRole = (userRole) => {
    const user_role = userRole.split(',');
    if (user_role.includes(userRoles.HR_Manager) || userRole === userRoles.SUPER_USER) {
      return 'HR_MANAGER';
    } else if (user_role.includes(userRoles.ASSISTANT_HR_MANAGER)) {
      return 'ASSISTANT_HR_MANAGER';
    } else if (user_role.includes(userRoles.HR_EXECUTIVE)) {
      return 'HR_EXECUTIVE';
    } else {
      return 'REPORTING_MANAGER';
    }
  }

  useEffect(() => {
    getList(); 
  },[prop?.dataChange]);

  useEffect(() => {
    if(isTrigger){
      getList();
      dispatch(AppActions.triggerFunction({isTrigger: false}));
    }
  },[isTrigger]);


  const getList =() => {
    setIsLoading(true);
    getOnLeaveList(validateUserRole(prop?.userRole), isReportingManager ? appUser?.EmployeeId : '', isReportingManager).then((res) => {
      if(res.data.statusCode === 200) {
        setOnLeaveList(res.data.data);
      }
      setIsLoading(false);
    }).catch(e => {
      setIsLoading(false);
    })
  }
 

  const dayStyle = {
    fontSize: '12px',
    color: '#5B5B5B',
    fontWeight: 'bold',
    marginBottom: '0.7rem'
  }

  const pStyle = {
    fontSize: '12px',
    color: '#7285A5',
    fontWeight: 400,
    marginBottom: '0.7rem'
  }

  const todayLeaveList = onLeaveList.filter((data) => {
    return data.timeStatus === 'Today' 
  })

  const thisWeekLeaveList = onLeaveList.filter((data) => {
    return data.timeStatus === 'This Week' 
  })

  const nextWeekLeaveList = onLeaveList.filter((data) => {
    return data.timeStatus === 'Next Week' 
  })

  return (
    <Card style={{ padding: '1rem', minHeight: '31rem' }}>
      <Grid item>
        <Typography style={{ fontSize: '12px' }} variant="h3">
          Who's on Leave
        </Typography>
        <Divider style={{ marginTop: '1rem', marginBottom: '1rem' }}></Divider>
      </Grid>
      <Grid className='hide-scroll-bar' style={{ maxHeight: '25.5rem', overflow: 'scroll' }}>
        <Grid item>
          <Typography style={dayStyle} variant="h5">
            Today
          </Typography>
          {todayLeaveList?.map((employee) => {
            return <EmployeeCard data={employee} isOnLeave={true}/>;
          })}
          {todayLeaveList.length === 0 &&
            (validateUserRole(prop?.userRole) === 'REPORTING_MANAGER'? (
              <Typography style={pStyle} fontWeight="light" variant="h5">
                {isLoading ? 'Loading...' : 'All reporters are available today'}
              </Typography>
            ) : (
              <Typography style={pStyle} fontWeight="light" variant="h5">
                {isLoading ? 'Loading...' : 'All employees are available today'}
              </Typography>
            ))
            }
        </Grid>
        <Divider
          style={{ marginTop: '0.7rem', marginBottom: '0.7rem' }}
        ></Divider>
        <Grid item>
          <Typography style={dayStyle} variant="h5">
            Remaining Days of This Week
          </Typography>
          {thisWeekLeaveList?.map((employee) => {
            return <EmployeeCard data={employee} isOnLeave={true}/>;
          })}
          {thisWeekLeaveList.length === 0 && 
          (validateUserRole(prop?.userRole) === 'REPORTING_MANAGER'? (
            <Typography style={pStyle} fontWeight="light" variant="h5">
              {isLoading ? 'Loading...' : 'All reporters are available this week'}
            </Typography>
          ) : (
            <Typography style={pStyle} fontWeight="light" variant="h5">
              {isLoading ? 'Loading...' : 'All employees are available this week'}
            </Typography>
          ))
          }
        </Grid>
        <Divider
          style={{ marginTop: '0.7rem', marginBottom: '0.7rem' }}
        ></Divider>
        <Grid item>
          <Typography style={dayStyle} variant="h5">
            Next Week
          </Typography>
          {nextWeekLeaveList?.map((employee) => {
            return <EmployeeCard data={employee} isOnLeave={true}/>;
          })}
          {nextWeekLeaveList.length === 0 && 
          (validateUserRole(prop?.userRole) === 'REPORTING_MANAGER'? (
            <Typography style={pStyle} fontWeight="light" variant="h5">
              {isLoading ? 'Loading...' : 'All reporters are available next week'}
            </Typography>
          ) : (
            <Typography style={pStyle} fontWeight="light" variant="h5">
              {isLoading ? 'Loading...' : 'All employees are available next week'}
            </Typography>
          ))
          }
        </Grid>
      </Grid>
    </Card>
  );
};

export default OnLeave;
